export default __webpack_public_path__ + "static/profile-64bdcb460fae40dea0ffcb03e244125f.jpg";